module.exports = __webpack_public_path__ + "ca7e9c3cf7af467692e060b60ded0bd8.jpg";